<template>
  <div class="category-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.category') }}</strong>
            </div>
            <b-col cols="12" class="text-center">

              <b-row class="categories-box">
                <b-col xl="12" class="text-left">
                  <div class="master-title">
                    {{$t('category.master_category')}}
                    <div class="sub-note">
                      <i class="fa fa-circle text-orange"></i> {{$t('category.include_sub_category')}}
                    </div>
                  </div>
                  <div class="header-right">
                    <button type="button" class="btn border-radius-4px bg-main" @click="openFormPopup('create', 1)">
                      <i class="fa fa-plus"></i>&nbsp; {{$t('category.new_category')}}
                    </button>

                  </div>
                </b-col>
                <b-col xl="12">
                  <b-dropdown id="ddown-right1"  :class="'category-item ' + (selected_master.id == item.id ? 'active' : '')" v-for="item in dataTable.items" :key="item.id" v-if="item.level == 1 && item.status">
                    <template slot="button-content">
                      <div class="category-title" @click="selectMaster(item)">
                        <i class="fa fa-circle text-orange" v-if="item.lower_categories.length > 0"></i> {{item.name[$session.get('lang')]}}
                      </div>
                      <div class="category-action">
                        <i class="fa fa-ellipsis-v"></i>
                      </div>
                    </template>
                    <b-dropdown-item href="#" @click="openFormPopup(item.uuid, item.level)"><i class="fa fa-edit"></i> {{$t('common.edit')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="deleteCategory(item)"><i class="fa fa-trash-o"></i> {{$t('common.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <b-col xl="12" class="text-left sub-category" v-if="selected_master.name != null">
                  <div class="sub-title">{{$t('category.sub_category_of', {category: selected_master.name[$session.get('lang')]})}}</div>
                </b-col>
                <b-col xl="12">
                  <span v-show="selected_master.lower_categories.length <= 0">
                    {{$t('category.no_sub_category')}}
                  </span>
                  <b-dropdown id="ddown-right" right :class="'category-item ' + (selected_master_sub.id == item.id ? 'active' : '')" v-for="item in selected_master.lower_categories" :key="item.id" v-if="item.status">
                    <template slot="button-content">
                      <div class="category-title">
                        {{item.name[$session.get('lang')]}}
                      </div>
                      <div class="category-action">
                        <i class="fa fa-ellipsis-v"></i>
                      </div>
                    </template>
                    <b-dropdown-item href="#" @click="openFormPopup(item.uuid, item.level)"><i class="fa fa-edit"></i> {{$t('common.edit')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="deleteSub(item)"><i class="fa fa-trash-o"></i> {{$t('common.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>


              <b-row class="categories-box">
                <b-col xl="12" class="text-left">
                  <div class="master-title">{{$t('category.sub_category')}}</div>
                  <div class="header-right">
                    <button type="button" class="btn border-radius-4px bg-main" @click="openFormPopup('create', 2)">
                      <i class="fa fa-plus"></i>&nbsp; {{$t('category.new_sub_category')}}
                    </button>
                  </div>
                </b-col>
                <b-col xl="12">
                  <b-dropdown id="ddown-right" right :class="'category-item ' + (selected_sub.id == item.id ? 'active' : '')" v-for="item in dataTable.items" :key="item.id" v-if="item.level == 2 && item.status">
                    <template slot="button-content">
                      <div class="category-title">
                        <i class="fa fa-circle text-orange" v-if="item.lower_categories.length > 0"></i> {{item.name[$session.get('lang')]}}
                      </div>
                      <div class="category-action">
                        <i class="fa fa-ellipsis-v"></i>
                      </div>
                    </template>
                    <b-dropdown-item href="#" @click="openFormPopup(item.uuid, item.level)"><i class="fa fa-edit"></i> {{$t('common.edit')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="addSub(item)"><i class="fa fa-arrow-up"></i> {{$t('category.add')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="deleteCategory(item)"><i class="fa fa-trash-o"></i> {{$t('common.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>

              <b-row class="categories-box">
                <b-col xl="12" class="text-left">
                  <div class="master-title">{{$t('category.group_tag')}}</div>
                  <div class="header-right">
                    <button type="button" class="btn border-radius-4px bg-main" @click="openSingleTypeFormPopup('create')">
                      <i class="fa fa-plus"></i>&nbsp; {{$t('category.new_group_tag')}}
                    </button>
                  </div>
                </b-col>
                <b-col xl="12">
                  <draggable v-model="group_tags" @end="onEndProduct">
                    <transition-group class="list-category-item">
                      <b-dropdown id="ddown-right2" right class="category-item" v-for="item in group_tags" :key="item.id">
                        <template slot="button-content">
                          <div class="category-title">
                            {{item.name[$session.get('lang')]}}
                          </div>
                          <div class="category-action">
                            <i class="fa fa-ellipsis-v"></i>
                          </div>
                        </template>
                        <b-dropdown-item href="#" @click="openSingleTypeFormPopup(item.uuid)"><i class="fa fa-edit"></i> {{$t('common.edit')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="deleteTag(item.uuid)"><i class="fa fa-trash-o"></i> {{$t('common.delete')}}</b-dropdown-item>
                      </b-dropdown>
                    </transition-group>
                  </draggable>
                </b-col>
              </b-row>
            </b-col>
            <div slot="footer">
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="publicSequence"> {{$t('common.publish')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal ref="category" size="lg" hide-footer hide-header>
      <base-form :uuid="uuid" :exist-category="existCategory" :level="level" @cancel="closeFormPopup" @success="successForm"></base-form>
    </b-modal>
    <b-modal ref="single_type" size="lg" hide-footer hide-header>
      <single-type-form :uuid="single_type_uuid" :exist-tags="existTags" @cancel="closeSingleTypePopup" @success="successSingleType"></single-type-form>
    </b-modal>
  </div>
</template>
<style>
  .categories-box .dropdown-toggle::after {
    display: none;
  }
  .categories-box .dropdown-toggle {
    padding: 0;
    background-color: transparent;
    border: none;
    width: 100%;
    text-align: center;
    height: 45px;
    line-height: 45px;
    border-radius: 4px;
  }
  .categories-box .dropdown-item i.fa {
    color: #000;
  }

  .categories-box .btn-secondary:not(:disabled):not(.disabled):active,
  .categories-box .btn-secondary:not(:disabled):not(.disabled).active,
  .categories-box .show > .btn-secondary.dropdown-toggle {
    background-color: #005da3;
    color: #fff;
  }
  .categories-box .dropdown-menu {
    margin: 2px 0 0 !important;
  }
</style>
<style scoped>
  .category-list .btn-save{
    float: right;
    margin-right: 22px;
  }
  .category-list .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  [draggable="true"] {
    /*
   To prevent user selecting inside the drag source
  */
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .categories-box {
    border-radius: 4px;
    background-color: #f5f7f9;
    border: 1px solid #e1e6eb;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }
  .master-title {
    float: left;
    font-size: 25px;
    font-weight: 600;
    padding: 20px 0;
    text-transform: uppercase;
  }
  .sub-title {
    font-size: 20px;
    font-weight: 600;
    padding: 10px 0;
    text-transform: uppercase;
  }
  .header-right {
    float: right;
    padding: 10px 0;
  }
  .header-right button {
    width: 100%;
    margin-bottom: 10px;
  }
  .sub-note {
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
  }
  .category-item {
    transition: all .5s;
    cursor: pointer;
    margin: 10px 10px 0 10px;
    float: left;
    min-width: 130px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 5px #bfbbbb;
    text-align: left;
    position: relative;
  }
  .category-item.active {
    background-color: #005da3;
    color: #fff;
  }
  .category-title {
    width: calc(100% - 20px);
    float: left;
    font-weight: 600;
    text-align: left;
    padding-left: 10px;
    line-height: 45px;
  }
  .category-item.active .category-title {
    color: #fff;
  }
  .category-action {
    font-weight: 400;
    float: right;
    width: 20px;
    text-align: center;
    background-color: transparent;
    border: none;
    height: 45px;
    line-height: 45px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .sub-category {
    margin-top: 10px;
    border-top: 1px solid #e1e6eb;
  }
  .action-popup {
    width: 100%;
    background-color: #fff;
    position: absolute;
    color: #000;
    border: 1px solid #e1e6eb;
    border-radius: 4px;
  }
  .action-popup > div:hover {
    background-color: #e3e3e3;
  }
  .action-edit {
    padding: 10px;
  }
  .action-delete {
    padding: 10px;
    border-top: 1px solid #e1e6eb;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import BaseForm from "./BaseForm"
import SingleTypeForm from "./SingleTypeForm"
import draggable from 'vuedraggable'
import axios from 'axios'

const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'CategoryList',
  components: {
    SingleTypeForm,
    SelectDropdown,
    DataTable,
    BaseForm,
    draggable
  },
  data: function () {
    return {
      existCategory: {},
      existTags: {},
      uuid: '',
      single_type_uuid: '',
      level: 1,
      type: 'like',
      statuses: [],
      levels: [],
      group_tags: [],
      selected_master: {
        lower_categories: []
      },
      selected_master_sub: {},
      selected_sub: {},
      action_sub: {},
      action_type: {},
      filter: {
        options: [],
        selected: null,
        active: '',
        level: '0',
        field: null,
        key: null,
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'slug',
            label: 'category_seo_name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'level',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return vm.levels[this.$session.get('lang')][data]
            }
          }
        ],
        sort: {
          field: 'sequence',
          type: 'asc'
        },
        currentPage: 1,
        total: 0,
        perPage: 500,
        source: null
      },
      item: {}
    }
  },
  methods: {
    publicSequence () {
      this.updateSequence(() => {
        let count = 0
        let max = 2
        this.axios.category.publishCategory(function (response) {
          count += 1
        })
        this.axios.category.publishSingleType(function (response) {
          count += 1
        })
        let flag = setInterval(() => {
          if (count >= max) {
            this.$toastr.success(this.$t('message.update_successful'), this.$t('message.success'), {})
            clearInterval(flag)
          }
        }, 500)
      })
    },
    updateSequence (cb) {
      let params = {
        categories: [],
        single_types: []
      }
      for (let i in this.dataTable.items) {
        params.categories.push({
          id: this.dataTable.items[i].id,
          sequence: this.dataTable.items[i].sequence
        })
        for (let s in this.dataTable.items[i].lower_categories) {
          params.categories.push({
            id: this.dataTable.items[i].lower_categories[s].id,
            sequence: this.dataTable.items[i].lower_categories[s].sequence
          })
        }
      }
      for (let i in this.group_tags) {
        if (this.group_tags[i].sequence == null || this.group_tags[i].sequence == '') {
          this.group_tags[i].sequence = i
        }
        params.single_types.push({
          id: this.group_tags[i].id,
          sequence: this.group_tags[i].sequence
        })
      }

      this.axios.menu.updateSequence(params, (response) => {
        cb()
      })
    },
    onEndProduct () {
      for (let i in this.group_tags) {
        this.group_tags[i]['sequence'] = i
      }
    },
    successSingleType () {
      this.$refs['single_type'].hide()
      this.refreshData()
    },
    closeSingleTypePopup () {
      this.$refs['single_type'].hide()
    },
    successForm () {
      this.$refs['category'].hide()
      this.refreshData()
    },
    closeFormPopup () {
      this.$refs['category'].hide()
    },
    openSingleTypeFormPopup (uuid) {
      this.single_type_uuid = uuid
      this.$refs['single_type'].show()
    },
    openFormPopup (uuid, level) {
      this.uuid = uuid
      this.level = level
      this.$refs['category'].show()
    },
    addSub (sub) {
      this.action_sub = {}
      for (let i in this.dataTable.items) {
        if (this.dataTable.items[i].id == this.selected_master.id) {
          for (let j in this.dataTable.items[i].lower_categories) {
            if (this.dataTable.items[i].lower_categories[j].id == sub.id) {
              return
            }
          }
          this.dataTable.items[i].lower_categories.push(sub)
        }
      }
      // this.selected_master.lower_categories.push(sub)
      let item = this._.cloneDeep(this.selected_master)
      let subIds = []
      for (let i in item.lower_categories) {
        subIds.push(item.lower_categories[i].id)
      }
      item.lower_categories = subIds
      vm.axios.category.updateCategory(item, respone => {
        if (respone.status === 200) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }
      }, error => {
        vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        console.log(error)
      })
    },
    deleteSub (sub) {
      this.action_sub = {}
      let subs = []
      for (let i in this.selected_master.lower_categories) {
        if (this.selected_master.lower_categories[i].id != sub.id) {
          subs.push(this.selected_master.lower_categories[i])
        }
      }
      this.selected_master.lower_categories = subs
      let item = this._.cloneDeep(this.selected_master)
      let subIds = []
      for (let i in item.lower_categories) {
        subIds.push(item.lower_categories[i].id)
      }
      item.lower_categories = subIds
      vm.axios.category.updateCategory(item, respone => {
        if (respone.status === 200) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }
      }, error => {
        vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        console.log(error)
      })
    },
    deleteCategory (item) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('category.delete_confirm'), options)
        .then(function (dialog) {
          let data = {
            uuid: item.uuid,
            status: 0
          }
          vm.axios.category.updateCategory(data, respone => {
            vm.$toastr.success(vm.$t('message.delete_successful'), vm.$t('message.success'), {})
            vm.refreshData()
          }, error => {
            vm.$toastr.error(vm.$t('message.delete_fail'), vm.$t('message.error'), {})
            console.log(error)
          })
        })
        .catch(function () {
        })
    },
    deleteTag (uuid) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('category.delete_confirm'), options)
        .then(function (dialog) {
          let data = {
            uuid: uuid,
            active: 0
          }
          vm.axios.category.updateStatusSingleType(data, respone => {
            vm.$toastr.success(vm.$t('message.delete_successful'), vm.$t('message.success'), {})
            vm.refreshData()
          }, error => {
            vm.$toastr.error(vm.$t('message.delete_fail'), vm.$t('message.error'), {})
            console.log(error)
          })
        })
        .catch(function () {
        })
    },
    actionSub (item, type) {
      this.action_sub = item
      this.action_type = type
      switch (type) {
        case 'master-sub':
          this.selected_master_sub = item
          break
        case 'sub':
          this.selected_sub = item
          break
      }
    },
    selectMaster (item) {
      this.action_sub = {}
      this.selected_master = item
    },
    selectSub (item) {
      this.action_sub = {}
      this.selected_sub = item
    },
    selectMasterSub (item) {
      this.action_sub = {}
      this.selected_master_sub = item
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }
      //get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type,
      }
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      if (this.filter.level != '0') {
        _data['level'] = this.filter.level
      }

      //process to send via get method
      let params = ''
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      //remove tail
      params = params.slice(0, -1)
      vm.axios.category.getCategoryList(params, function (response) {
        vm.dataTable.items = response.data.data.items
        vm.dataTable.total = response.data.data.pagination.total
        let flag = false
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.existCategory[langs[l]] = []
        }
        for (let i in vm.dataTable.items) {
          if (vm.dataTable.items[i].level == 1 && vm.dataTable.items[i].status && !flag) {
            vm.selected_master = vm.dataTable.items[i]
            flag = true
          }
          if (vm.dataTable.items[i].level == 1 && vm.dataTable.items[i].status ) {
            for (let l1 in langs) {
              vm.existCategory[langs[l1]].push(vm.dataTable.items[i].name[langs[l1]].toLowerCase())
            }
          }
        }
        vm.$forceUpdate('existCategory')
      })

      vm.axios.category.getSingleTypes(function (response) {
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.existTags[langs[l]] = []
        }
        vm.group_tags = response.data.data.items
        for (let i in vm.group_tags) {
          for (let l1 in langs) {
            if (vm.group_tags[i].name != null && vm.group_tags[i].name.hasOwnProperty(langs[l1])) {
              vm.existTags[langs[l1]].push(vm.group_tags[i].name[langs[l1]].toLowerCase())
            }
          }
        }
        vm.$forceUpdate('existTags')
      })
    },
    editItem: function(uuid){
      vm.$router.push({name: 'category_edit', params: { uuid: uuid }})
    },
    createCategory: function(){
      vm.$router.push({name: 'category_create', params: { uuid: 'create' }})
    },
    publishCategory: function () {
      vm.axios.category.publishCategory(function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
      })
    }
  },
  created: function () {
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()
    let allowedFilter = ['name', 'slug']
    let langs = Object.keys(this.$i18n.messages)
    for (let l in langs) {
      this.levels[langs[l]] = {
        '0': this.$t('common.all', langs[l]),
        '1': this.$t('category.master_category', langs[l]),
        '2': this.$t('category.sub_category', langs[l])
      }
    }
    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name
      if (allowedFilter.includes(vm.dataTable.fields[i].name)
        && vm.dataTable.fields[i].filter != null
        && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }
    vm.$Progress.start()
    vm.refreshData()
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.level': function (val) {
      vm.refreshData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/category/List.vue